export default __webpack_public_path__ + "static/media/notFound.8ba190b3.png";